import axios from "axios";

const admin = axios.create({
  // baseURL: "http://202.131.123.110:1337",
  // baseURL: "http://localhost:1337",
  // baseURL: "http://202.131.123.110:1337",
  baseURL: "https://vibo-api.herokuapp.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// admin.interceptors.request.use(
//   config => {
//     if (localStorage.getItem("token")) {
//       config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );
// admin.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem("token")}`;
// admin.defaults.headers.post["Content-Type"] = "application/json";

export default admin;



// WEBPACK FOOTER //
// ./services/guest.js